












import {Component, Vue} from 'vue-property-decorator';

@Component
export default class Home extends Vue {

    // noinspection JSUnusedGlobalSymbols
    public mounted(): void {
        if (this.$locator.repository.token === '') {
            this.$locator.routing.signIn();
        }
    }
}
